import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M615.176872 345L0 960.291794 615.176872 1575.46867 696.426648 1494.21889 219.960496 1017.75274 1920 1017.75274 1920 902.830849 219.960496 902.830849 696.426648 426.249776z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconArrowLeftLine = /*#__PURE__*/function (_Component) {
  _inherits(IconArrowLeftLine, _Component);

  var _super = _createSuper(IconArrowLeftLine);

  function IconArrowLeftLine() {
    _classCallCheck(this, IconArrowLeftLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconArrowLeftLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconArrowLeftLine /> is deprecated. Please use <IconArrowStartLine /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArrowLeft",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconArrowLeftLine.displayName = "IconArrowLeftLine";
  return IconArrowLeftLine;
}(Component);

IconArrowLeftLine.glyphName = 'arrow-left';
IconArrowLeftLine.variant = 'Line';
IconArrowLeftLine.deprecated = true;
IconArrowLeftLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArrowLeftLine;
export { IconArrowLeftLine };